
import styled from 'styled-components';

export const Plate = styled.div`
  border-radius: 20px;
  background: #fff;
  &:hover {
    box-shadow: 0px 12px 24px 0px rgba(57, 78, 127, 0.2);
  }
  display: flex;
  flex-direction: column;
`;

export const LabelBlock = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #F0DEFF;
  border-radius: 20px 20px 0 0;
`;

export const Content = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ResultBlock = styled.div`
  display: grid;
  gap: 32px;
  margin-bottom: 56px;
`;

export const Text = styled.p`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
`;

export const Row = styled.div`
    display: flex;
    gap: 16px;
    display: flex;
    align-items: flex-start;
    
`;
export const Count = styled.div`
  min-width: 128px;
  height: 48px;
  border-radius: 6px;
  background: #F4F5F6;
  font-size: 30px;
  line-height: 40px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Description = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #09152699
`;

export const DownloadButton = styled.button`
  border: none;
  background: inherit;
  padding: 0;
  font-size: 16px;
  line-height: 20.8px;
  font-weight: 400;
  color: #12B7E7;
  text-decoration: underline;
`;

export const NumberList = styled.div`
  display: flex;
  gap: 8px
`;

export const TitlePlate = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  min-height: 24px;
`;